import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Button)`
  /* Base button styling - all mode-specific styles are now handled via props */
`;
